import { HttpClient, HttpParams } from '@angular/common/http';
import {Injectable} from '@angular/core';
import { environment } from 'src/environments/environment';
import { ActionFile } from 'src/generated/graphql';

@Injectable({
  providedIn: 'root'
})
export class FileService {
  constructor(private http: HttpClient) {}

  uploadFile(dir:string, file: File) {
    const formData = new FormData();
    formData.append('file', file);
    
    const url = environment.base_url + `/v1/upload/file/${dir}`;

    return this.http.post(url, formData);
  }

  createActionFile(id: string, actionFile: ActionFile) {
    const actionFileDTO = {
      url: actionFile.url,
      name: actionFile.name,
      bucketRequestId: actionFile.bucketRequestId,
      fileName: actionFile.fileName,
      eTag: actionFile.eTag,
      versionId: actionFile.versionId
    };
    return this.http.post(environment.base_url + `/action/file/${id}`, actionFileDTO);
  }

  getActionFileById(id: string): Promise<ActionFile> {
    return this.http.get(environment.base_url + `/action/file/${id}`).toPromise<any>();   
  }

  async deleteActionFileFromBucket(actionFile: ActionFile) {
    const bucketFile = {
      fileName: actionFile.fileName,
      eTag: actionFile.eTag,
      versionId: actionFile.versionId
    }

    return this.http.post(environment.base_url + `/upload/file/delete`, bucketFile).toPromise();
  }
}
